import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Observable, retry, timer } from 'rxjs';
import { AppConfigurationService } from '../services/app-configuration.service';

@Injectable()
export class HttpRetryInterceptor implements HttpInterceptor {
  retryAttempts: number = 0;

  constructor(private readonly appConfigurationService: AppConfigurationService) {
    if (appConfigurationService.config !== null && appConfigurationService.config !== undefined) {
      this.retryAttempts = appConfigurationService.config.retryAttempts;
    }
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(retry({ count: this.retryAttempts, delay: this.shouldRetry }));
  }

  shouldRetry(error: HttpErrorResponse) {
    if (error.status >= HttpStatusCode.InternalServerError && this.retryAttempts > 0) {
      return timer(1000);
    }

    throw error;
  }
}
